
import React, { useEffect, useMemo, useState } from 'react'
import { Controller, useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { Badge, Button, Col, DropdownItem, DropdownMenu, DropdownToggle, Form, FormGroup, FormText, Input, Modal, ModalBody, Spinner, UncontrolledDropdown } from 'reactstrap';
import { BlockBetween, BlockDes, BlockHead, BlockHeadContent, BlockTitle, Icon, RSelect } from '../../../../components/Component';
import ReactDataTable from './ReactDataTable/ReactDataTable';
import { WEBSITE_BASE_URL } from '../../../../config';
import ToastExample from '../../../../helpers/toast';
import Content from '../../../../layout/content/Content';
import Head from '../../../../layout/head/Head';
import { createCoupon, deleteCoupon, getAllCoupons, toggleCoupon, updateCoupon } from '../../../../redux/admin/promotion/action';
import { nonActiveFormSubmissionStatus, openFormLoading } from '../../../../redux/common/actions';
import * as yup from "yup";
import { yupResolver } from '@hookform/resolvers/yup';
import { getAllCities } from '../../../../redux/admin/cities/actions';
import { getAllItems } from '../../../../redux/admin/item/action';
import { getAllStores } from '../../../../redux/admin/store/action';
import noimage from '../../../../assets/images/noimage.png'
import { Image, Table } from 'antd';
import { ColorRing } from 'react-loader-spinner';

const Coupons = () => {
    const dispatch = useDispatch(); //defining dispatch

    //function to get data from backend
    useEffect(() => {
        dispatch(getAllCoupons()).then((response) => {
            if (response.payload.length > 0) {
                setLoading(false);
            }
        })
        dispatch(getAllCities());
        dispatch(getAllItems());
        dispatch(getAllStores());
    }, []);

    //to store data from application state to a constant
    const getSelectors = (state) => ({
        coupons: state.promotion.coupons,
        store_categories: state.store.store_categories,
        stores: state.store.stores,
        items: state.item.items.data,
        cities: state.cities.cities,
        form_loading: state.common.form_loading,
        form_submission_status: state.common.form_submission_status,

    });
    const { store_categories, stores, coupons, items, cities, form_loading, form_submission_status, } = useSelector(getSelectors);
    const [loading, setLoading] = useState(true);

    const [editingCoupon, setEditingCoupon] = useState([]);   //edit category state

    const [deletingCoupon, setDeletingCoupon] = useState([]);   //delete category state

    const [formData, setFormData] = useState([]);   //form data state defined

    const [showToast, setShowToast] = useState(false);   //toast state

    const [data, setData] = useState([]);  //data state defined

    const [cityId, setCityId] = useState([]);  //data state defined

    const [selectedStores, setSelectedStores] = useState([]);  //isMultiple state defined
    const [couponType, setCouponType] = useState([]);  //isMultiple state defined
    const [couponsTableDatas, setCouponsTableDatas] = useState([]);  //isMultiple state defined
    const [image, setImage] = useState([]);  // state defined

    //modal state
    const [modal, setModal] = useState({
        edit: false,
        add: false,
        delete: false,
    });

    // ---------------Start multi select Stores ------------

    const getSelectedStores = (stores) => {
        const allStores = [];
        const selectedStores = [];
        const storesIds = [];
        if (modal.edit) {
            editingCoupon.stores.map((selected_stores) => (
                storesIds.push(selected_stores.id)
            ))
        }

        let selected = stores.forEach((store) => {
            let selected_user = storesIds.includes(store.id)
            if (selected_user) {
                allStores.push(store);
            }

        });

        console.log(allStores, 'aaa')
        allStores?.forEach((element) => {
            const dataObj = {
                value: element.id,
                label: element.name,
            };
            selectedStores.push(dataObj);
        });
        console.log(selectedStores, 'selectedStores')
        return selectedStores;
    };

    const getStoresDropDown = (stores) => {
        const allStores = [];
        stores.forEach((element) => {
            if (cityId == element.city_id) {
                const dataObj = {
                    value: element.id,
                    label: element.name,
                };
                allStores.push(dataObj);
            }
        });
        return allStores;
    };
    // ---------------End multi select Stores ------------
    // ---------------Start multi select items ------------
    const getSelectedItems = (items) => {
        const allItems = [];
        const selectedItems = [];
        const itemsIds = [];
        if (modal.edit) {
            editingCoupon.items.map((selected_items) => (
                itemsIds.push(selected_items.id)
            ))
        }
        let selected = items.forEach((item) => {
            let selected_user = itemsIds.includes(item.id)
            if (selected_user) {
                allItems.push(item);
            }

        });

        allItems?.forEach((element) => {
            const dataObj = {
                value: element.id,
                label: element.name,
            };
            selectedItems.push(dataObj);
        });
        return selectedItems;
    };
    const getItemsDropDown = (items) => {
        const allItems = [];

        items.forEach((element) => {
            if (element.store && element.store.city_id == cityId) {
                const dataObj = {
                    value: element.id,
                    label: element.name,
                };
                allItems.push(dataObj);
            }
        });
        return allItems;
    };

    // ---------------End multi select items ------------

    //to open add modal
    const openAddModal = () => {
        setEditingCoupon([]);
        dispatch(nonActiveFormSubmissionStatus());
        setTimeout(() => {
            setModal({ add: true });
        }, 100);
        setCouponType("STORE")
    };

    //to open edit modal
    const openEditModal = (category) => {
        setModal({ edit: true });
        dispatch(nonActiveFormSubmissionStatus());
        setCityId(category.city_id)
        setSelectedStores(category.stores?.map((store) => (
            { value: store.id, label: store.name }
        )))
        setEditingCoupon(category);
        setCouponType(category.coupon_type)
    };

    //to open delete modal
    const openDeleteModal = (category) => {
        setModal({ delete: true });
        dispatch(nonActiveFormSubmissionStatus());
        setDeletingCoupon(category);
    };

    //store lists
    const listCities = cities?.map((city) => (
        { value: city.id, label: city.name }

    ));
    const AllItems = items?.map((item) => (
        { value: item.id, label: item.name }
    ));
    const discount_type = [
        { value: 'FIXED', label: 'FIXED' },
        { value: 'PERCENTAGE', label: 'PERCENTAGE' }
    ];
    const coupon_types = [
        { value: 'STORE', label: 'STORE' },
        { value: 'ITEM', label: 'ITEM' },
    ];
    const user_types = [
        { value: 'ALL', label: 'Unlimited Times For All Users' },
        { value: 'ONCENEW', label: 'Once For New User For First Order' },
        { value: 'ONCE', label: 'Once Per User' },
        { value: 'CUSTOM', label: 'Define Custom Limit Per User' },
    ];

    //form validation with yup
    const categorySchema = yup.object({

        name: yup.string(),
        // radius: yup.string(),
        // latitude: yup.string(),
        // longitude: yup.string(),
        type: yup.string(),
        store_ids: yup.array(),
        item_ids: yup.array(),
        discount_type: yup.string(),
        code: yup.string(),
        coupon_discount: yup.string(),
        max_discount: yup.string(),
        start_date: yup.string(),
        end_date: yup.string(),
        min_sub_total: yup.string(),
        max_count: yup.string(),
        sub_total_message: yup.string(),
        user_type: yup.string(),
        coupon_type: yup.string(),
        city_id: yup.string(),
        description: yup.string(),
    });



    //form values
    const defaultValues = useMemo(
        () => ({
            id: editingCoupon?.id || "",
            name: editingCoupon?.name || "",
            // radius: editingCoupon?.radius || "",
            // latitude: editingCoupon?.latitude || "",
            // longitude: editingCoupon?.longitude || "",
            description: editingCoupon?.description || "",
            discount_type: editingCoupon?.discount_type || "",
            code: editingCoupon?.code || "",
            coupon_discount: editingCoupon?.coupon_discount || "",
            max_discount: editingCoupon?.max_discount || "",
            start_date: editingCoupon?.start_date || "",
            end_date: editingCoupon?.end_date || "",
            min_sub_total: editingCoupon?.min_sub_total || "",
            sub_total_message: editingCoupon?.sub_total_message || "",
            user_type: editingCoupon?.user_type || "",
            coupon_type: editingCoupon?.coupon_type || "",
            max_count: editingCoupon?.max_count || "",
            type: editingCoupon?.type || "",
            city_id: editingCoupon?.city_id || "",
            store_ids: editingCoupon?.store_ids || [],
            item_ids: editingCoupon?.item_ids || [],

        }),
        [editingCoupon]
    );
    console.log(editingCoupon, 'editingCoupon')

    //form methods
    const methods = useForm({
        resolver: yupResolver(categorySchema),
        defaultValues: defaultValues,
    });

    //useform methods
    const {
        register,
        handleSubmit,
        reset,
        formState: { errors },
        control
    } = methods;

    //submit function
    const onFormSubmit = (submitData) => {
        dispatch(openFormLoading());
        console.log(submitData, 'submitdata');
        let store_ids = JSON.stringify(submitData?.store_ids);
        let item_ids = JSON.stringify(submitData?.item_ids);
        const new_data = new FormData();
        new_data.append('id', editingCoupon?.id);
        new_data.append('name', submitData?.name);
        new_data.append('token', localStorage.getItem('accessToken'));
        if (image) {
            new_data.append('image', image);
        }
        // new_data.append('radius', submitData?.radius);
        // new_data.append('latitude', submitData?.latitude);
        // new_data.append('longitude', submitData?.longitude);
        new_data.append('description', submitData?.description);
        new_data.append('discount_type', submitData?.discount_type);
        new_data.append('code', submitData?.code);
        new_data.append('coupon_discount', submitData?.coupon_discount);
        new_data.append('max_discount', submitData?.max_discount);
        new_data.append('start_date', submitData?.start_date);
        new_data.append('end_date', submitData?.end_date);
        new_data.append('min_sub_total', submitData?.min_sub_total);
        new_data.append('sub_total_message', submitData?.sub_total_message);
        new_data.append('user_type', submitData?.user_type);
        new_data.append('coupon_type', submitData?.coupon_type);
        new_data.append('max_count', submitData?.max_count);
        new_data.append('city_id', submitData?.city_id);
        new_data.append('store_ids', store_ids);
        new_data.append('item_ids', item_ids);

        if (modal.edit) {
            setTimeout(() => {
                dispatch(updateCoupon(new_data));
            }, 50);
        } else if (modal.add) {
            dispatch(createCoupon(new_data));
        } else if (modal.delete) {
            dispatch(deleteCoupon(deletingCoupon?.id));
        }
        resetForm();
    };

    // to reset the form
    const resetForm = () => {
        setFormData({
            name: "",
            // radius: "",
            // latitude: "",
            // longitude: "",
            description: "",
            discount_type: "",
            code: "",
            coupon_discount: "",
            max_discount: "",
            start_date: "",
            end_date: "",
            min_sub_total: "",
            sub_total_message: "",
            user_type: "",
            coupon_type: "",
            max_count: "",
            city_id: "",
            store_ids: [],
            item_ids: [],
        });
    };

    //to close modal
    const onFormCancel = () => {
        setModal({ edit: false, add: false, delete: false });
        document.getElementByClass("invalid").innerHTML = "";
        resetForm();
    };

    //category toggle
    const handleCategoryStatus = (e, id) => {
        dispatch(toggleCoupon(id));
        setTimeout(() => {
            dispatch(getAllCoupons());
            setShowToast(true);
        }, 500);

        setTimeout(() => {
            setShowToast(false);
        }, 3000);
    };

    //submit toast
    useEffect(() => {
        if (modal.add == true && form_loading == false && form_submission_status == true) {
            setTimeout(() => {
                dispatch(getAllCoupons());
                setData(coupons);
                setModal({ add: false });
                setShowToast(true);
            }, 500);
            setTimeout(() => {
                setShowToast(false);
            }, 3000);
        }

        if (modal.edit == true && editingCoupon && form_loading == false && form_submission_status == true) {
            dispatch(getAllCoupons());
            setData(coupons);
            setModal({ edit: false });
            setShowToast(true);
            reset(defaultValues);
            setTimeout(() => {
                setShowToast(false);
            }, 3000);
        } else {
            reset(defaultValues);
        }

        if (modal.delete == true && form_loading == false && form_submission_status == true) {
            setTimeout(() => {
                dispatch(getAllCoupons());
                setData(coupons);
                setModal({ delete: false });
                setShowToast(true);
            }, 500);
            setTimeout(() => {
                setShowToast(false);
            }, 3000);
        }
    }, [createCoupon, form_loading, modal, form_submission_status]);


    const dataTableColumns = [
        {
            name: "Name",
            selector: (row) => row.name,
            sortable: true,
        },
        {
            name: "Image",
            selector: (row) => row.image,
            cell: (row) => (
                <div className="user-card mt-2 mb-2">
                    <Image
                        style={{
                            height: "15vh",
                            width: "15vh",
                            objectFit: 'cover',
                        }}
                        src={row?.image ? row?.image : noimage}
                    />
                </div>
            )
        },
        {
            name: "Type",
            selector: (row) => row.coupon_type,
            sortable: true,
        },
        {
            name: "Coupon Code",
            selector: (row) => row.code,
            sortable: true,
        },
        {
            name: "Discount Type",
            selector: (row) => row.discount_type,
            sortable: true,
        },
        {
            name: "Discount",
            selector: (row) => row.coupon_discount,
            sortable: true,
        },
        {
            name: "Expiry Date",
            selector: (row) => row.end_date,
            sortable: true,
        },

        {
            name: "Status",
            selector: (row) => row.startDate,
            cell: (row) => (
                <Button color={row?.is_active ? "success" : "danger"} onClick={(e) => {
                    handleCategoryStatus(e, row?.id)
                }}>
                    {row?.is_active ? <Icon name="stop-circle-fill" /> : <Icon name="play-circle-fill" />}
                </Button>
            )
        },
        {
            name: "Action",
            selector: (row) => row.salary,
            cell: (row) => (
                <div className="user-card mt-2 mb-2">
                    <DropdownTrans row={row} />
                </div>
            )
        },
    ];

    //action dropdown
    const DropdownTrans = ({ row }) => {
        return (
            <UncontrolledDropdown>
                <DropdownToggle tag="a" className="text-soft dropdown-toggle btn btn-icon btn-trigger">
                    <Icon name="more-h"></Icon>
                </DropdownToggle>
                <DropdownMenu right>
                    <ul className="link-list-plain">
                        <li>
                            <DropdownItem tag="a" onClick={() => openEditModal(row)}>
                                <Icon name="pen" />Edit
                            </DropdownItem>
                        </li>
                        <li>
                            <DropdownItem tag="a"
                                href="#dropdownitem"
                                onClick={() => openDeleteModal(row)}>
                                <Icon name="trash" />Delete
                            </DropdownItem>
                        </li>
                    </ul>
                </DropdownMenu>
            </UncontrolledDropdown>
        );
    };

    return (
        <React.Fragment>
            {loading ? (
                <Content >
                    <div className='d-flex align-items-center justify-content-center' style={{ minHeight: '75vh' }}>
                        <ColorRing
                            visible={true}
                            height="80"
                            width="80"
                            ariaLabel="blocks-loading"
                            wrapperStyle={{}}
                            wrapperClass="blocks-wrapper"
                            colors={['#fcc314', '#fcc314', '#fcc314', '#fcc314', '#fcc314']}
                        />
                    </div>
                </Content>
            ) :
                <React.Fragment>
                    <Head title="Coupons"></Head>

                    {/* content */}
                    <Content>
                        <BlockHead size="sm">
                            <BlockBetween>
                                <BlockHeadContent>
                                    <BlockTitle tag="h3" page>
                                        Coupons
                                    </BlockTitle>
                                    <BlockDes className="text-soft">
                                        <p>You have total {coupons?.length} coupons.</p>
                                    </BlockDes>
                                </BlockHeadContent>
                                <BlockHeadContent>
                                    <div className="toggle-wrap nk-block-tools-toggle">
                                        <ToastExample
                                            show={showToast}
                                        />
                                        <div className="toggle-expand-content">
                                            <ul className="nk-block-tools g-3">
                                                {/* <li>
                                            <a
                                                href="#export"
                                                onClick={(ev) => {
                                                    ev.preventDefault();
                                                }}
                                                className="btn btn-white btn-outline-light"
                                            >
                                                <Icon name="download-cloud"></Icon>
                                                <span>Export</span>
                                            </a>
                                        </li> */}
                                                <li className="nk-block-tools-opt">
                                                    <Button color="primary" className="btn-icon"
                                                        onClick={() => openAddModal()}
                                                    >
                                                        <Icon name="plus"></Icon>
                                                    </Button>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </BlockHeadContent>
                            </BlockBetween>
                        </BlockHead>

                        <ReactDataTable data={coupons} columns={dataTableColumns} expandableRows pagination />

                    </Content>

                    {/* add and edit modal */}
                    <Modal
                        isOpen={modal.add || modal.edit}
                        toggle={() => setModal({ add: false })}
                        className="modal-dialog-centered"
                        size="lg"
                    >
                        <ModalBody>
                            <a
                                href="#cancel"
                                onClick={(ev) => {
                                    ev.preventDefault();
                                    onFormCancel();
                                }}
                                className="close"
                            >
                                <Icon name="cross-sm"></Icon>
                            </a>
                            <div className="p-2">
                                <h5 className="title">{modal.edit ? "Editing Coupon - " + editingCoupon?.name : "Add Coupon"}</h5>
                                <div className="mt-4">
                                    <Form className="row gy-4" onSubmit={handleSubmit(onFormSubmit)} encType="multipart/formData">
                                        <Col md="12">
                                            <FormGroup>
                                                <label className="form-label">Coupon Name</label>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    name="name"
                                                    placeholder="Enter Coupon Name"
                                                    ref={register({ required: "This field is required" })}
                                                />
                                                {errors.name && <span className="invalid">{errors.name.message}</span>}
                                            </FormGroup>
                                        </Col>
                                        <Col md="12" style={modal.edit ? { display: 'block' } : { display: 'none' }}>
                                            <FormGroup>
                                                <label className="form-label">Current Image </label>
                                                <div className="" id={editingCoupon.id}>
                                                    {editingCoupon?.image ?
                                                        <Image src={editingCoupon.image} alt="banner" style={{ objectFit: 'cover', height: '20vh' }} />
                                                        :
                                                        <>
                                                            <img src={noimage} alt="item category" style={{ height: '20vh', }} />
                                                            <span className='m-1' style={{ color: '#330033', fontSize: '9px' }}>No image found</span>
                                                        </>
                                                    }
                                                </div>
                                            </FormGroup>
                                        </Col>
                                        <Col md="12">
                                            <FormGroup>
                                                <label className="form-label" >Image </label>
                                                <input
                                                    className="form-control"
                                                    type="file"
                                                    name="image"
                                                    accept="image/png, image/jpeg, image/jpg"
                                                    onChange={(e) => {
                                                        setImage(e.target.files[0])
                                                    }}
                                                />
                                                {errors.image && <span className="invalid">{errors.image.message}</span>}
                                                <FormText>Upload resolution 1200x1200 pixel</FormText>
                                            </FormGroup>
                                        </Col>
                                        <Col md="12">
                                            <FormGroup>
                                                <label className="form-label">Description</label>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    name="description"
                                                    placeholder="Enter Description"
                                                    ref={register({ required: "This field is required" })}
                                                />
                                                {errors.description && <span className="invalid">{errors.description.message}</span>}
                                            </FormGroup>
                                        </Col>
                                        {/* <Col md="6">
                                    <FormGroup>
                                        <label className="form-label">Radius</label>
                                        <input
                                            className="form-control"
                                            type="number"
                                            name="radius"
                                            ref={register({
                                                required: "This field is required",
                                            })}
                                            placeholder="Enter city maximum delivery radius"
                                        />
                                        {errors.radius && <span className="invalid">{errors.radius.message}</span>}
                                    </FormGroup>
                                </Col>
                                <Col md="6">
                                    <FormGroup>
                                        <label className="form-label">Latitude </label>
                                        <input
                                            className="form-control"
                                            type="text"
                                            name="latitude"
                                            placeholder="Enter City Latitude"
                                            ref={register({
                                                required: "This field is required",
                                            })}
                                        />
                                        {errors.latitude && <span className="invalid">{errors.latitude.message}</span>}
                                    </FormGroup>
                                </Col>
                                <Col md="6">
                                    <FormGroup>
                                        <label className="form-label">Longitude</label>
                                        <input
                                            className="form-control"
                                            type="text"
                                            name="longitude"
                                            placeholder="Enter City Longitude"
                                            ref={register({ required: "This field is required" })}
                                        />
                                        {errors.longitude && <span className="invalid">{errors.longitude.message}</span>}
                                    </FormGroup>
                                </Col> */}
                                        <Col md="6">
                                            <FormGroup>
                                                <label className="form-label">Discount Type</label>
                                                <div className="form-control-wrap">
                                                    <Controller
                                                        name="discount_type"
                                                        control={control}
                                                        render={({ onChange, value, ref }) => (
                                                            <RSelect
                                                                options={discount_type}
                                                                onChange={(val) => onChange(val.value)}
                                                                defaultValue={discount_type.find((type) => type.value === value)}
                                                            />
                                                        )}
                                                        ref={register({ required: "This field is required" })}
                                                    />
                                                    {errors.discount_type && (
                                                        <span className="invalid" style={{ color: '#e85347', fontSize: '11px', fontStyle: 'italic' }}>Please choose a Discount Type</span>
                                                    )}
                                                </div>
                                            </FormGroup>
                                        </Col>
                                        <Col md="6">
                                            <FormGroup>
                                                <label className="form-label">Code</label>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    name="code"
                                                    ref={register({
                                                        required: "This field is required",
                                                    })}
                                                    placeholder="Enter code"
                                                />
                                                {errors.code && <span className="invalid">Code is a required field</span>}
                                            </FormGroup>
                                        </Col>
                                        <Col md="6">
                                            <FormGroup>
                                                <label className="form-label">Coupon Discount</label>
                                                <input
                                                    className="form-control"
                                                    type="number"
                                                    onWheel={(e) => e.target.blur()}
                                                    min={0}
                                                    name="coupon_discount"
                                                    ref={register({
                                                        required: "This field is required",
                                                    })}
                                                    placeholder="Enter Coupon Discount"
                                                />
                                                {errors.coupon_discount && <span className="invalid">Coupon Discount is a required field</span>}
                                            </FormGroup>
                                        </Col>
                                        <Col md="6">
                                            <FormGroup>
                                                <label className="form-label">Maximum Discount</label>
                                                <input
                                                    className="form-control"
                                                    type="number"
                                                    onWheel={(e) => e.target.blur()}
                                                    min={0}
                                                    name="max_discount"
                                                    ref={register({
                                                        required: "This field is required",
                                                    })}
                                                    placeholder="Enter Maximum Discount"
                                                />
                                                {errors.max_discount && <span className="invalid">Maximum Discount is a required field</span>}
                                            </FormGroup>
                                        </Col>
                                        <Col md="6">
                                            <FormGroup>
                                                <label className="form-label">Start Date</label>
                                                <input
                                                    className="form-control"
                                                    type="date"
                                                    name="start_date"
                                                    ref={register({
                                                        required: "This field is required",
                                                    })}
                                                    placeholder="Select Start Date"
                                                />
                                                {errors.start_date && <span className="invalid">Start Date is a required field</span>}
                                            </FormGroup>
                                        </Col>
                                        <Col md="6">
                                            <FormGroup>
                                                <label className="form-label">End Date</label>
                                                <input
                                                    className="form-control"
                                                    type="date"
                                                    name="end_date"
                                                    ref={register({
                                                        required: "This field is required",
                                                    })}
                                                    placeholder="Select End Dated"
                                                />
                                                {errors.end_date && <span className="invalid">End Date is a required field</span>}
                                            </FormGroup>
                                        </Col>
                                        <Col md="6">
                                            <FormGroup>
                                                <label className="form-label">Max No of use in Total</label>
                                                <input
                                                    className="form-control"
                                                    type="number"
                                                    onWheel={(e) => e.target.blur()}
                                                    min={0}
                                                    name="max_count"
                                                    ref={register({
                                                        required: "This field is required",
                                                    })}
                                                    placeholder="Enter coupon Max Count"
                                                />
                                                {errors.max_count && <span className="invalid">Max Count is a required field</span>}
                                            </FormGroup>
                                        </Col>
                                        <Col md="6">
                                            <FormGroup>
                                                <label className="form-label">Min Sub Total</label>
                                                <input
                                                    className="form-control"
                                                    type="number"
                                                    onWheel={(e) => e.target.blur()}
                                                    min={0}
                                                    name="min_sub_total"
                                                    ref={register({
                                                        required: "This field is required",
                                                    })}
                                                    placeholder="Enter your Coupon Min sub total"
                                                />
                                                {errors.min_sub_total && <span className="invalid">Min Sub is a required field</span>}
                                            </FormGroup>
                                        </Col>
                                        <Col md="6">
                                            <FormGroup>
                                                <label className="form-label">Sub Total Not Reached Message</label>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    name="sub_total_message"
                                                    ref={register({
                                                        required: "This field is required",
                                                    })}
                                                    placeholder="Enter coupon sub total not reached message"
                                                />
                                                {errors.sub_total_message && <span className="invalid">Sub Total Message is a required field</span>}
                                            </FormGroup>
                                        </Col>
                                        <Col md="6">
                                            <FormGroup>
                                                <label className="form-label">User Type</label>
                                                <div className="form-control-wrap">
                                                    <Controller
                                                        name="user_type"
                                                        control={control}
                                                        render={({ onChange, value, ref }) => (
                                                            <RSelect
                                                                options={user_types}
                                                                onChange={(val) => onChange(val.value)}
                                                                defaultValue={user_types.find((city) => city.value === value)}
                                                            />
                                                        )}
                                                        ref={register({ required: "This field is required" })}
                                                    />
                                                    {errors.user_type && (
                                                        <span className="invalid" style={{ color: '#e85347', fontSize: '11px', fontStyle: 'italic' }}>Please choose a Store</span>
                                                    )}
                                                </div>
                                            </FormGroup>
                                        </Col>
                                        <Col md="6">
                                            <FormGroup>
                                                <label className="form-label">City</label>
                                                <div className="form-control-wrap">
                                                    <Controller
                                                        name="city_id"
                                                        control={control}
                                                        render={({ onChange, value, ref }) => (
                                                            <RSelect
                                                                options={listCities}
                                                                onChange={(val) => {
                                                                    onChange(val.value)
                                                                    setCityId(val.value)
                                                                }}
                                                                defaultValue={listCities.find((city) => city.value === value)}
                                                            />
                                                        )}
                                                        ref={register({ required: "This field is required" })}
                                                    />
                                                    {errors.city_id && (
                                                        <span className="invalid" style={{ color: '#e85347', fontSize: '11px', fontStyle: 'italic' }}>Please choose a City</span>
                                                    )}
                                                </div>
                                            </FormGroup>
                                        </Col>
                                        <Col md="6">
                                            <FormGroup>
                                                <label className="form-label">Coupon Type</label>
                                                <div className="form-control-wrap">
                                                    <Controller
                                                        name="coupon_type"
                                                        control={control}
                                                        render={({ onChange, value, ref }) => (
                                                            <RSelect
                                                                options={coupon_types}
                                                                onChange={(val) => {
                                                                    onChange(val.value)
                                                                    setCouponType(val.value)
                                                                }}
                                                                defaultValue={coupon_types.find((city) => city.value === value)}
                                                            />
                                                        )}
                                                        ref={register({ required: "This field is required" })}
                                                    />
                                                    {errors.coupon_type && (
                                                        <span className="invalid" style={{ color: '#e85347', fontSize: '11px', fontStyle: 'italic' }}>Please choose a Coupon Type</span>
                                                    )}
                                                </div>
                                            </FormGroup>
                                        </Col>
                                        <Col md="12" style={couponType == "STORE" ? { display: 'block' } : { display: 'none' }}>
                                            <FormGroup>
                                                <label className="form-label">Store</label>
                                                <div className="form-control-wrap">
                                                    <Controller
                                                        name="store_ids"
                                                        control={control}
                                                        render={({ onChange, ref }) => (
                                                            <RSelect
                                                                options={getStoresDropDown(stores)}
                                                                isMulti
                                                                onChange={(val) => onChange(val.map((c) => c.value))}
                                                                defaultValue={getSelectedStores(stores)}
                                                            ></RSelect>
                                                        )}
                                                    />

                                                </div>
                                            </FormGroup>
                                        </Col>
                                        <Col md="12" style={couponType == "ITEM" ? { display: 'block' } : { display: 'none' }}>
                                            <FormGroup>
                                                <label className="form-label">Items</label>
                                                <div className="form-control-wrap">
                                                    <Controller
                                                        name="item_ids"
                                                        control={control}
                                                        render={({ onChange, ref }) => (
                                                            <RSelect
                                                                options={getItemsDropDown(items)}
                                                                isMulti
                                                                onChange={(val) => onChange(val.map((c) => c.value))}
                                                                defaultValue={getSelectedItems(items)}
                                                            ></RSelect>
                                                        )}
                                                    />

                                                </div>
                                            </FormGroup>
                                        </Col>
                                        <Col md="12">
                                            <ul className="align-center flex-wrap flex-sm-nowrap gx-4 gy-2">
                                                <li>
                                                    <Button type="submit" color="primary" size="lg" className="btn-block">
                                                        {form_loading ? (
                                                            <>
                                                                <Spinner size="sm" color="light" /> {modal.edit ? "Updating Coupon" : "Creating New Coupon"}
                                                            </>
                                                        ) : (
                                                            <React.Fragment>{modal.edit ? "Update Coupon" : "Add New Coupon"}</React.Fragment>
                                                        )}
                                                    </Button>
                                                </li>
                                                <li>
                                                    <a href="#cancel" onClick={(ev) => {
                                                        ev.preventDefault();
                                                        onFormCancel();
                                                    }}
                                                        className="link link-light"   >
                                                        Cancel
                                                    </a>
                                                </li>
                                            </ul>
                                        </Col>
                                    </Form>
                                </div>
                            </div>
                        </ModalBody>
                    </Modal>

                    {/* delete modal */}
                    <Modal
                        isOpen={modal.delete}
                        toggle={() => setModal({ delete: false })}
                        className="modal-dialog-centered"
                    // size="lg"
                    >
                        <ModalBody className='pt-3 pb-2'>
                            <a
                                href="#cancel"
                                onClick={(ev) => {
                                    ev.preventDefault();
                                    onFormCancel();
                                }}
                                className="close"
                            >
                                <Icon name="cross-sm"></Icon>
                            </a>
                            <div className="p-2">
                                <h5 className="title">Delete Coupon{' '}
                                    <Badge color="primary">
                                        {deletingCoupon?.name}
                                    </Badge>
                                    {' '}
                                    ?
                                </h5>
                                <div className='mt-2'>
                                    <span>This Item category will be deleted. Do you really want to delete this category ?</span>
                                </div>
                                <div className="mt-3">
                                    <ul className="align-center flex-wrap flex-sm-nowrap gx-4">
                                        <li>
                                            <Button onClick={(e) => {
                                                e.preventDefault();
                                                onFormSubmit();
                                            }} color="danger" className="px-4 btn-block">
                                                {form_loading ? (
                                                    <>
                                                        <Spinner size="sm" color="light" />Deleting
                                                    </>
                                                ) : (
                                                    <React.Fragment>Delete</React.Fragment>
                                                )}
                                            </Button>
                                        </li>
                                        <li>
                                            <a
                                                href="#cancel"
                                                onClick={(ev) => {
                                                    ev.preventDefault();
                                                    onFormCancel();
                                                }}
                                                className="link link-light"
                                            >
                                                Cancel
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </ModalBody>
                    </Modal>
                </React.Fragment>
            }
        </React.Fragment>
    );
}

export default Coupons
